// extracted by mini-css-extract-plugin
export default {"navbar-link":"TopNavItem_navbar-link__ODQut"};